<template>
  <div>
    <i-select
      :value="value"
      :filterable="true"
      :clearable="true"
      :loading="is_loading"
      v-on="$listeners"
    >
      <i-option
        v-for="item in items"
        :key="item.id"
        :value="item.id"
        :label="item.name"
      />
    </i-select>
  </div>
</template>

<script>
  import { UsersService } from '@administration/services/UsersService';

  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },

    data() {
      return {
        is_loading: true,
        items: []
      };
    },

    created() {
      UsersService.getList()
        .then(items => (this.items = items.data))
        .finally(() => (this.is_loading = false));
    }
  };
</script>
